﻿export class VideoSnippet {
    public static imgReplacement($: JQueryStatic): void {
        $(".video-snippet").each(function (idx, val) {
            const originalImg = $(val).find(".video-snippet__img").attr("src");
            const videoContainer = $(val).find(
                ".video-snippet__video-container"
            );
            const backgroundImg = "url(" + originalImg + ")";
            $(videoContainer).css("background", backgroundImg);
        });
    }

    public static clickHandler($: JQueryStatic): void {
        $(".video-snippet").each(function (idx, val) {
            const videoSrc = $(val).find("iframe").attr("src");

            $(val).find("iframe").attr("src", "");

            const autoplay = videoSrc + "?autoplay=1";

            $(val)
                .find(".video-snippet__custom-play-btn")
                .on("click", function () {
                    $(val)
                        .find("iframe")
                        .addClass("show")
                        .attr("src", autoplay);
                    $(this).css("display", "none");
                });
        });
    }
}

export const textVideoCLickHandler = () => {
    const snippets = document.querySelectorAll(".text-video");

    if (!snippets) {
        return;
    }

    snippets.forEach((snippet) => {
        showVideo(snippet);
    });
};

function showVideo(snippet) {
    const playbtn = snippet.querySelector(".text-video__play-button");
    const video: HTMLIFrameElement = snippet.querySelector(
        ".text-video__video"
    ) as HTMLIFrameElement;

    if (!video) {
        return
    }

    const autoplay = video.src + "?autoplay=1";

    video.src = "";

    playbtn?.addEventListener("click", () => {
        video.src = autoplay;
        video.classList.add("text-video__video--active");
    });
}
